import io from 'socket.io-client';
import { FC, ReactNode, useEffect } from 'react';
import { Box, alpha, lighten, useTheme } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import './SidebarLayout.css';
import Sidebar from './Sidebar';
import Header from './Header';
import { getAccessToken } from 'src/utils/authService';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { setSocket } from 'src/redux-store/slices/socketSlice';
import toast from 'react-hot-toast';
import { handleGetNotification } from 'src/utils/sendNotification';
import { setSessionData } from 'src/utils/CommonFunctions';
import getEnvVars from 'src/config/env';

interface SidebarLayoutProps {
  children?: ReactNode;
}
/* eslint-disable @typescript-eslint/no-unused-vars */
const SidebarLayout: FC<SidebarLayoutProps> = ({ children }) => {
  const theme = useTheme();

  const location = useLocation();
  const path = location?.pathname;

  const dispatch = useDispatch()
  const userDetails = useSelector((store: RootState) => store.user.userDetails);

  const list = useSelector((state: any) => state.notifications.notifications)
  const currentTownshipDetails = useSelector(
    (state: RootState) => state?.township?.townshipDetails
  );
  const token = getAccessToken()
  const IsDashboard = userDetails?.UserRole === 'Super Admin' ? -1 : ((path.indexOf('dashboard') !== -1 || path.indexOf('payment-methods') !== -1 || path === '/') ? 1 : -1);

  const initSocketConnection = () => {
    const { socketUrl } = getEnvVars()
    const query = {
      UserID: userDetails?.UserID,
      TownshipID: currentTownshipDetails?.id,
    };

    const newSocket = io(socketUrl, {
      path: '/socket.io/',
      withCredentials: true,
      transports: ['polling', 'websocket'],
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      query
    });
    newSocket.on('connect', () => {
      // connected
    });

    newSocket.on('connect_error', (err) => {
      console.error('Socket.IO connect_error:', err?.message || err);
    });

    newSocket.on('notification', (data) => {
      toast.success(data?.message)
      handleGetNotification(dispatch)
    });

    dispatch(setSocket(newSocket));
  };

  useEffect(() => {
    if (token) {
      setSessionData('Login_Sucess', 'true');
      initSocketConnection()
    }

  }, [token])

  return (
    <>
      <Box
        sx={{
          flex: 1,
          height: '100%',
          '.MuiPageTitle-wrapper': {
            background:
              theme.palette.mode === 'dark'
                ? alpha(theme.palette.common.white, 0.05) // Updated for MUI v5 usage
                : alpha(theme.palette.common.white, 0.1), // Updated for MUI v5 usage
            marginBottom: theme.spacing(4),
            boxShadow:
              theme.palette.mode === 'dark'
                ? `0 1px 0 ${alpha(
                  lighten(theme.palette.primary.main, 0.7),
                  0.15
                )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
                : `0px 2px 4px -3px ${alpha(
                  theme.palette.common.black,
                  0.1
                )}, 0px 5px 12px -4px ${alpha(
                  theme.palette.common.black,
                  0.05
                )}`
          }
        }}
      >

        <Header IsDashboard={IsDashboard} />
        <Sidebar IsDashboard={IsDashboard} />
        <Box
          sx={{
            position: 'relative',
            zIndex: 5,
            display: 'block',
            flex: 1,
            pt: theme.spacing(8), // Adjusting pt based on header height
            [theme.breakpoints.up('lg')]: {
              ml: (IsDashboard !== 1) && theme.spacing(30) // Adjusting for sidebar width 
            }
          }}
        >
          <Box display="block" className="sidebar_children_wrapper">
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SidebarLayout;
